import './App.css';
import { Outlet, useNavigate } from "react-router-dom";
import TopBar from './components/topbar';
import "./styles/index.scss"
import { useEffect } from 'react';


function App({children}) {
  const navigate = useNavigate()
  useEffect(() => {
    navigate("/users")
  },[])
  return (
    <div className="light-theme App">
      <TopBar /> 
      <Outlet />
    </div>
  );
}

export default App;
